import { jsx as _jsx } from "react/jsx-runtime";

function SvgReimburse() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.245.564A.5.5 0 0112.5 1v1.011C18.343 2.273 23 7.092 23 13c0 6.075-4.925 11-11 11S1 19.075 1 13a10.97 10.97 0 013.3-7.856 1 1 0 111.4 1.429A8.97 8.97 0 003 13a9 9 0 109.5-8.986V5a.5.5 0 01-.794.404l-3-2.181a.5.5 0 01.035-.832l3-1.819a.5.5 0 01.504-.008zm-.822 6.503h1.153c.225 0 .4.177.4.405v.985a2.57 2.57 0 012.23 2.3c0 .101-.024.228-.1.303a.413.413 0 01-.3.127h-1.153c-.2 0-.35-.127-.4-.303a.64.64 0 00-.602-.48h-1.002c-.526 0-.977.379-1.028.859-.025.278.075.556.25.758a.929.929 0 00.702.328h.877a2.91 2.91 0 012.155.96c.577.633.827 1.441.752 2.275-.125 1.264-1.077 2.3-2.355 2.578v1.036a.397.397 0 01-.401.405h-1.153a.397.397 0 01-.4-.405v-.985a2.57 2.57 0 01-2.23-2.3c0-.101.024-.228.1-.303a.413.413 0 01.3-.127h1.153c.2 0 .35.127.4.303a.64.64 0 00.602.48h1.002c.527 0 .978-.378 1.028-.859a1.032 1.032 0 00-.25-.758.929.929 0 00-.703-.328H11.7c-1.554 0-2.882-1.163-3.032-2.654-.15-1.542.877-2.906 2.355-3.184V7.472c0-.228.176-.405.401-.405z"
    }, void 0)
  }), void 0);
}

export default SvgReimburse;